import * as ReactRouter from 'react-router-dom'
import * as R from 'ramda'
import querystring from 'querystring'

export function useSearchQuery() {
  const location = ReactRouter.useLocation()

  return querystring.parse(R.drop(1, location.search))
}
